<dsy-table zebraShadowRows [data]="tableDataSignal()" [conf]="tableConfSignal()">
  @for (col of columnsSignal(); track col.key) {
    <div class="mb-1" [attr.slot]="'header-' + col.key">
      @if (col.key === 'checkbox') {
        <dsy-checkbox [dsyValue]="selectionStore.allSelectedSignal()" [handleChange]="handleToggleAll" event-bubbles is-event-composed size="small"></dsy-checkbox>
      } @else {
        <dsy-heading level-size="lg">{{ col.header }}</dsy-heading>
      }
    </div>
  }
  @for (row of rowsSignal(); track row.id; let i = $index) {
    <dsy-checkbox
      slot="cell-{{ i }}-checkbox"
      aria-label="Select row"
      [dsyValue]="isSelected(row.id)"
      [handleChange]="handleToggleRow(row.id)"
      [isDisabled]="!row.isUserTheOwner"
      event-bubbles
      is-event-composed
      size="small"
    />
    <p class="high-alerts__cell" slot="cell-{{ i }}-program">{{ row.programName }}</p>
    <p class="high-alerts__cell" slot="cell-{{ i }}-window">
      <dr-ops-stream-ui-app-tag [variant]="getTagVariant(row.window)" [label]="row.window"></dr-ops-stream-ui-app-tag>
    </p>
    <p class="high-alerts__cell high-alerts__cell--createdBy" slot="cell-{{ i }}-createdBy">
      <dsy-avatar
        size="x-small"
        resource-url="assets/images/avatar-placeholder.png"
        is-fullname-visible
        [firstName]="row.createdByName"
        [lastName]="''"
        fullname-additional-style="padding-left: 0.7rem"
      />
    </p>
    <p class="high-alerts__cell" slot="cell-{{ i }}-startDate">{{ row.startDate | date: 'dd/MM/yy HH:mm' }}</p>
    <p class="high-alerts__cell" slot="cell-{{ i }}-endDate">{{ row.endDate | date: 'dd/MM/yy HH:mm' }}</p>
    <p class="high-alerts__cell high-alerts__cell--notes" slot="cell-{{ i }}-notes">{{ row.notes }}</p>
    @if (isCurrentStatus() && row.isUserTheOwner) {
      <p class="high-alerts__cell high-alerts__cell--edit" slot="cell-{{ i }}-action">
        <dsy-clickable-icon name="edit_square" library="material" size="1.4rem" color="default" (click)="onEdit(row)" />
      </p>
    }
    <p class="high-alerts__cell" slot="cell-{{ i }}-action">
      <dsy-button variant="link" [iconSide]="'right'" [iconName]="'chevron_right'" [iconLibrary]="'material'" [iconSize]="'1.4rem'" (click)="onView(row)"> View </dsy-button>
    </p>
  }
</dsy-table>
